import React from "react";
import "./BlogInput.scss"
import search from "../../assets/search.svg"
const BlogInput = ({ value, setValue }) => {
    return (
        <div className="BlogInput">
            <img alt="" src={search} />
            <input
                placeholder="Search blog posts..."
                value={value}
                onChange={(e) => {
                    setValue(e.target.value)
                }}
            />
        </div>
    )
}
export default BlogInput